import React from "react";
import { Search, RotateCw } from "lucide-react";

const inputClass =
  "bg-white border border-gray-200 rounded-xl md:rounded-lg text-base md:text-sm font-semibold text-gray-700 outline-none transition-all focus:border-red-500 focus:ring-2 focus:ring-red-500/10 min-h-[44px] md:min-h-0";

/**
 * Thanh lọc tab "Lịch sử & liên hệ" — file UI riêng.
 */
const AttendanceHistoryFilter = ({
  searchTerm,
  onSearchChange,
  selectedDate,
  onDateChange,
  isMobile,
  onRefresh,
}) => {
  return (
    <div
      className={`bg-white rounded-xl border border-gray-100 shadow-sm ${
        isMobile ? "p-3 space-y-2" : "p-4"
      }`}
    >
      <div className={`flex ${isMobile ? "flex-col gap-2" : "flex-wrap items-center gap-2.5"}`}>
        <div className={`flex gap-2 ${isMobile ? "w-full" : ""}`}>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => onDateChange(e.target.value)}
            className={`${isMobile ? "flex-1" : "w-auto shrink-0"} px-3 py-2 ${inputClass}`}
          />
          <button
            type="button"
            onClick={() => onRefresh?.()}
            className="h-11 w-11 md:h-9 md:w-9 flex items-center justify-center rounded-xl md:rounded-lg border border-gray-200 bg-white text-gray-500 active:text-red-500 active:border-red-200 transition-all shrink-0 touch-manipulation"
            title="Làm mới"
          >
            <RotateCw size={16} />
          </button>
        </div>

        <div className={`relative group ${isMobile ? "w-full" : "w-full max-w-sm"}`}>
          <Search
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-red-500"
            size={16}
          />
          <input
            type="search"
            enterKeyHint="search"
            placeholder={
              isMobile ? "Tìm học sinh..." : "Tìm theo tên học sinh, lớp, phụ huynh..."
            }
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className={`w-full pl-10 pr-3 py-2 ${inputClass}`}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendanceHistoryFilter;
